// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Bokk","left":"styles_left__2A3-s","desktopActions":"styles_desktopActions__2Dv31","title":"styles_title__2gXT7"};